/** BBKaoss visual language — dark hardware, KP-orange heat, cyan second touch. */
export const theme = {
  bg: '#0a0a0f',
  panel: '#12121a',
  panelEdge: '#23232f',
  text: '#e8e8f0',
  textDim: '#7a7a88',
  accent: '#ff9500', // touch 1 / primary (KP orange)
  accent2: '#00d5ff', // touch 2
  good: '#3ddc84',
  warn: '#ffcc33',
  bad: '#ff4455',
  padBg: '#07070c',
  padGrid: '#1a1a26',
} as const;
